export default __webpack_public_path__ + "static/media/male_blue.6f5498c8.png";